<div class="notification-container">
  <div class="box-border"></div>
  <div class="notification-wrap" padding>
    <div class="heading-wrap" layout layout-vertical margin-bottom-small>
      <div class="heading">
        {{ 'app.product_updates.reload_component.notification.heading' | translate }}
      </div>
      <div
        [innerHTML]="
          'app.product_updates.reload_component.notification.subheading'
            | translate: { link: 'https://updates.recruitee.com' }
        "
        class="subheading"
      ></div>
    </div>
    <div class="actions" layout layout-align-items-center layout-justify-flex-end>
      <rt-button
        (click)="close$.emit(); reloadNotificationAnalytics.trackComponentActions('dismiss')"
        variant="plain"
        margin-right-small-x
      >
        {{ 'app.product_updates.reload_component.notification.dismiss' | translate }}
      </rt-button>
      <rt-button
        (click)="reload$.emit(); reloadNotificationAnalytics.trackComponentActions('reload')"
        variant="primary"
      >
        <rt-icon name="refresh"></rt-icon>
        <span>{{ 'app.product_updates.reload_component.notification.reload' | translate }}</span>
      </rt-button>
    </div>
  </div>
</div>
